import React from 'react';

const PreTransactionDelayedStatusIcon = ({ fontSize = 'medium', ...props }) => {
  const sizeMap = {
    small: 20,
    medium: 24,
    large: 28
  };

  const size = sizeMap[fontSize] || 24;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M19.8125 12.5C19.8125 7.90913 16.0909 4.1875 11.5 4.1875C6.90913 4.1875 3.1875 7.90913 3.1875 12.5C3.1875 17.0909 6.90913 20.8125 11.5 20.8125C16.0909 20.8125 19.8125 17.0909 19.8125 12.5ZM21 12.5C21 17.7467 16.7467 22 11.5 22C6.25329 22 2 17.7467 2 12.5C2 7.25329 6.25329 3 11.5 3C16.7467 3 21 7.25329 21 12.5Z"
        fill="#C14701"
      />
      <path
        d="M14.7458 9.96667C14.7458 9.7093 14.715 9.50438 14.6252 9.26468C14.5282 9.00618 14.41 8.80836 14.2467 8.64503L14.2278 8.6257L14.2104 8.60522C14.0937 8.4652 13.8686 8.31159 13.5699 8.16222C13.3558 8.05519 13.056 7.9875 12.6873 7.9875H9.28333C8.95541 7.9875 8.68958 7.72167 8.68958 7.39375C8.68958 7.06583 8.95541 6.8 9.28333 6.8H12.6873C13.1894 6.8 13.6817 6.89074 14.101 7.10035C14.4289 7.26434 14.8271 7.50078 15.1056 7.82553C15.406 8.13238 15.5997 8.48081 15.7373 8.84759C15.8849 9.24122 15.9333 9.59071 15.9333 9.96667C15.9333 10.3336 15.8874 10.7247 15.7373 11.1252L15.7322 11.1379L15.7268 11.1507C15.575 11.5049 15.3352 11.8334 15.1226 12.0885L15.1056 12.109L15.0867 12.1283C14.8017 12.4133 14.4716 12.6477 14.101 12.833L14.089 12.8392L14.0766 12.8446C13.6063 13.0536 13.1108 13.0939 12.6479 13.0939H11.0252C10.6973 13.0939 10.4315 12.828 10.4314 12.5002C10.4314 12.1722 10.6972 11.9064 11.0252 11.9064H12.6479C13.0508 11.9064 13.3445 11.8676 13.5849 11.763C13.8321 11.6376 14.0446 11.4852 14.2266 11.3072C14.3983 11.099 14.5449 10.887 14.629 10.6969C14.7133 10.4674 14.7458 10.2288 14.7458 9.96667Z"
        fill="#C14701"
      />
      <path
        d="M8.68958 17.6062V7.39375C8.68958 7.06583 8.95541 6.8 9.28333 6.8C9.61125 6.8 9.87708 7.06583 9.87708 7.39375V17.6062C9.87708 17.9341 9.61125 18.1999 9.28333 18.1999C8.95541 18.1999 8.68958 17.9341 8.68958 17.6062Z"
        fill="#C14701"
      />
    </svg>
  );
};

export default PreTransactionDelayedStatusIcon;
